(() => {
  if (customElements.get('toolbar-mobile')) return;
  class Toolbarmobile extends HTMLElement {
    connectedCallback() {
      if (this.onResize) return;
      this.onResize = () => { this.activate(); this.setHeight(); };
      window.addEventListener('resize', this.onResize);
      if ('ResizeObserver' in window) {
        this.sizeObserver = new ResizeObserver(() => this.setHeight());
        this.sizeObserver.observe(this);
      }
      this.onResize();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      this.sizeObserver?.disconnect();
      this.onResize = null;
      document.body.style.removeProperty('--toolbar-mobile-height');
    }

    activate() {
      const header = document.querySelector(".header[data-sticky-state='inactive']");
      this.classList.toggle('active', header === null);
    }

    setHeight() {
      document.body.style.setProperty('--toolbar-mobile-height', `${this.clientHeight}px`);
    }
  }
  customElements.define('toolbar-mobile', Toolbarmobile);
})();
